// How long ago something was written, in the page's language: "4 個月前" on a
// Traditional Chinese page, "4 months ago" on an English one.
import { getCurrentLocale } from 'utils/localeUtils'

const UNITS = [
  ['year', 31536000],
  ['month', 2592000],
  ['day', 86400],
  ['hour', 3600],
  ['minute', 60]
]

// @param {string} dateString an ISO timestamp
// @param {Object} options
// @param {Date} options.now defaults to the current time
// @returns {string}
export function timeAgo(dateString, { now = new Date() } = {}) {
  const locale = getCurrentLocale()
  const seconds = Math.floor((now - new Date(dateString)) / 1000)

  // numeric 'always' keeps "2 天前" instead of "前天", which is easier to compare
  // at a glance in a list of posts.
  const format = new Intl.RelativeTimeFormat(locale, { numeric: 'always' })
  for (const [unit, size] of UNITS) {
    const count = Math.floor(seconds / size)
    if (count >= 1) return format.format(-count, unit)
  }
  // "現在" / "now"
  return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(0, 'second')
}
